import axios from '@/api/axios'

const createNtzTemplate = (template) => {
  return axios.post('/ntz-templates', template)
}

const getNtzsTemplate = () => {
  return axios.get('/ntz-templates')
}

const getNtzsTemplateBySchoolId = (params) => {
  return axios.get(`/ntz-templates`, {params}).then((response) => response.data)
}

const getNtzTemplate = (id) => {
  return axios.get(`/ntz-templates/${id}`)
}

const updateNtzTemplate = (id, template) => {
  return axios.put(`/ntz-templates/${id}`, template)
}

const deleteNtzTemplate = (id) => {
  return axios.delete(`/ntz-templates/${id}`)
}

export default {
  createNtzTemplate,
  getNtzsTemplate,
  getNtzTemplate,
  updateNtzTemplate,
  deleteNtzTemplate,
  getNtzsTemplateBySchoolId,
}
